import { makeStyles } from "@mui/styles";
import { Theme } from "@material-ui/core";

export const useStyles = makeStyles((theme: Theme) => ({
    // Table css
    row: {
      cursor: "pointer",
    },
    hover: {
      "&:hover": {
        backgroundColor: "#293368 !important",
      },
    },
    iconColor: {
      "&.MuiIconButton-root": {
        color: "#1976d2",
      },
    },
    iconFilterButtonBg: {
      "&.MuiIconButton-root": {
        color: "#1976d2",
        backgroundColor: "#E5E7F1",
      },
    },
    iconFilterButtonNonBg: {
      "&.MuiIconButton-root": {
        color: "#1976d2",
        backgroundColor: "transparent",
      },
    },
    tableRow1: {
      "&.MuiTableRow-root": {
        backgroundColor: "#242C59",
  
        "&:hover": {
          backgroundColor: "#242C5990",
        },
      },
    },
    tableRow2: {
      "&.MuiTableRow-root": {
        backgroundColor: "#2D376D",
  
        "&:hover": {
          backgroundColor: "#2D376D70",
        },
      },
    },
    tableBodyTypography: {
      "&.MuiTypography-root": {
        fontWeight: 500,
        fontSize: "14px",
        color: "#FFF",
      },
    },
  
    tableHeadTypography: {
      "&.MuiTableCell-root": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "31px",
        color: "#E6E1E5",
        textAlign: "center",
      },
    },
    tableBodyCell: {
      "&.MuiTableCell-root": {
        textAlign: "center",
      },
    },
    // Header css
    criticalControlSec: {
      "& .MuiInputBase-root": {
        borderRadius: "5px",
        border: "1px solid #8476ef",
        background: "#293368",
        padding: "12px !important",
        "& .MuiAutocomplete-input": {
          padding: "0 !important",
        },
      },
      "& .MuiInputBase-input": {
        color: "#FFF",
        fontFamily: "Poppins",
        fontSize: "14px",
        "&::placeholder": {
          color: "#FFF",
        },
      },
      "& .MuiAutocomplete-endAdornment": {
        top: "12px",
      },
      "& .css-19kzrtu": {
        padding: 0,
      },
    },
    fliterMenus: {
      display: "flex",
      gap: "12px",
      justifyContent: "flex-end",
      "& .MuiButtonBase-root": {
        borderRadius: "6px",
        border: "0.895px solid #8476EF",
        background: "#293368",
        display: "flex",
        height: "46px",
        padding: "10px 20px",
        alignItems: "center",
        gap: "20px",
        fontFamily: "Poppins",
        fontSize: "14px",
        fontWeight: 400,
        maxWidth: "max-content",
        width: "100%",
        "& .MuiButton-iconSizeMedium": {
          marginRight: 0,
        },
      },
      "& .MuiTabs-scroller": {
        overflow: "visible !important",
        "& .MuiButtonBase-root": {
          margin: 0,
          borderColor: "#ABA7AD",
          background: "#232A58",
          "&:first-child": {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
          "&:nth-child(2)": {
            borderRadius: 0,
          },
          "&:last-child": {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
        },
        "& .Mui-selected": {
          borderColor: "#8476EF",
          background:
            "linear-gradient(0deg, rgba(132, 118, 239, 0.30) 0%, rgba(132, 118, 239, 0.30) 100%), #232A58",
        },
      },
    },
    datePickerBox: {
      "&.rs-picker-default ": {
        "& .rs-picker-toggle.rs-btn": {
          background: "#293368 !important",
          borderRadius: "10px",
          border: "1px solid #8476EF",
          padding: "14px 32px",
          fontWeight: 500,
        },
        "& .rs-picker-toggle-caret": {
          display: "none",
        },
      },
      "& .rs-picker-toggle-textbox": {
        background: "#293368",
        color: "#fff",
        fontSize: "13px",
      },
      "& .rs-stack": {
        "& .rs-stack-item": {
          "& .rs-picker-toggle-clean": {
            top: "14px !important",
            // background: "blue",
          },
        },
        "& .rs-picker-toggle-textbox": {
          padding: "14px 32px",
          color: "#fff",
        },
      },
      "& .rs-picker-toggle-value, .rs-picker-toggle-placeholder": {
        color: "#fff !important",
      },
    },
    multiDropdown: {
      "& .select__single-value": {
        color: "#fff !important",
        padding: "13px",
      },
      "& .select__input": {
        color: "white !important",
      },
      width: "100%",
      "& .select__control": {
        background: "#293368",
        padding: "11.5px 16px",
        "& .select__multi-value": {
          // background: "#8476EF",
          // padding: "6px 10px",
          "& .select__multi-value__label": {
            color: "#FFF",
            fontSize: "14px",
          },
          "& .select__multi-value__remove": {
            "&:hover": {
              backgroundColor: "transparent",
              color: "#FFF",
            },
          },
        },
        "& .select__indicator-separator": {
          display: "none",
        },
      },
      "& .select__menu ": {
        "& .select__menu-list": {
          padding: 0,
          "& .select__option ": {
            background: "#293368",
          },
        },
      },
  
      "& .MuiFormLabel-root ": {
        top: "-25px",
        background: "#293368",
        padding: "2px 10px",
      },
    },
    bookmarkDialog: {
      "& .MuiDialogTitle-root": {
        fontSize: "20px",
        fontWeight: 500,
        marginBottom: "0px",
        padding: "0px",
      },
      "& .MuiTypography-body1": {
        color: "#FFF",
        textAlign: "center",
        fontFamily: "Poppins",
        fontSize: "14px",
      },
  
      "& .contentWrapper": {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "28px",
      },
      "& .MuiAutocomplete-endAdornment": {
        right: "0px !important",
      },
      "& .MuiAutocomplete-root": {
        marginTop: "50px",
      },
      "& .MuiAutocomplete-clearIndicator": {
        background: "transparent",
        "& .MuiSvgIcon-root": {
          color: "#fff",
        },
      },
      "& .btnFoot": {
        display: "flex",
        gap: "12px",
        width: "100%",
        justifyContent: "flex-end",
        "& .MuiButtonBase-root": {
          borderRadius: "6px",
          border: "0.895px solid #8476EF",
          background: "#293368",
          display: "flex",
          height: "46px",
          padding: "10px 20px",
          alignItems: "center",
          gap: "20px",
          fontFamily: "Poppins",
          fontSize: "14px",
          fontWeight: 400,
          maxWidth: "max-content",
          width: "100%",
          "& .MuiButton-iconSizeMedium": {
            marginRight: 0,
          },
        },
        "& .saveBtn": {
          background: "#8476EF",
        },
      },
    },
    tableGrid: {
      marginTop: "24px",
      marginBottom: "24px",
    },
    autoCompletetSelect: {
      display: "contents",
    },
    backButtonAndAutoComplete: {
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      flexDirection: "row",
    },
    tagsConatiner: {
      marginTop: "10px",
      marginLeft: "10px",
      display: "flex",
      flexDirection: "column",
      color: "black",
    },
  }));
